const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

/**
 * Get all seasonal pricing with optional filters
 */
export const getSeasonalPricing = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.room_type_id) params.append('room_type_id', filters.room_type_id);
  if (filters.year) params.append('year', filters.year);
  if (filters.month) params.append('month', filters.month);
  
  const queryString = params.toString();
  const url = `${API_BASE_URL}/seasonal-pricing${queryString ? '?' + queryString : ''}`;
  
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error('Failed to fetch seasonal pricing');
  }
  return response.json();
};

/**
 * Get seasonal price for a specific room type, year, and month
 * Returns seasonal price if exists, otherwise returns base price
 */
export const getSeasonalPrice = async (roomTypeId, year, month) => {
  const response = await fetch(
    `${API_BASE_URL}/seasonal-pricing/price/${roomTypeId}/${year}/${month}`
  );
  if (!response.ok) {
    throw new Error('Failed to fetch seasonal price');
  }
  return response.json();
};

/**
 * Get all seasonal pricing for a specific year grouped by room type
 */
export const getSeasonalPricingByYear = async (year) => {
  const response = await fetch(`${API_BASE_URL}/seasonal-pricing/year/${year}`);
  if (!response.ok) {
    throw new Error('Failed to fetch seasonal pricing by year');
  }
  return response.json();
};

/**
 * Create or update a single seasonal pricing entry
 */
export const upsertSeasonalPricing = async (data) => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const token = user.token;
  const response = await fetch(`${API_BASE_URL}/seasonal-pricing`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify(data)
  });
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to save seasonal pricing');
  }
  return response.json();
};

/**
 * Bulk update seasonal pricing for a room type for the whole year
 */
export const bulkUpdateSeasonalPricing = async (roomTypeId, year, months) => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const token = user.token;
  const response = await fetch(`${API_BASE_URL}/seasonal-pricing/bulk`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify({
      room_type_id: roomTypeId,
      year,
      months
    })
  });
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to bulk update seasonal pricing');
  }
  return response.json();
};

/**
 * Delete a seasonal pricing entry
 */
export const deleteSeasonalPricing = async (id) => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const token = user.token;
  const response = await fetch(`${API_BASE_URL}/seasonal-pricing/${id}`, {
    method: 'DELETE',
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to delete seasonal pricing');
  }
  return response.json();
};

/**
 * Delete all seasonal pricing for a room type and year
 */
export const deleteSeasonalPricingByYear = async (roomTypeId, year) => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const token = user.token;
  const response = await fetch(`${API_BASE_URL}/seasonal-pricing/${roomTypeId}/${year}`, {
    method: 'DELETE',
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to delete seasonal pricing');
  }
  return response.json();
};
